import { render, staticRenderFns } from "./SalesClientYear.vue?vue&type=template&id=734db4a6"
import script from "./SalesClientYear.vue?vue&type=script&lang=js"
export * from "./SalesClientYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports